import { render, staticRenderFns } from "./CoordonneesProfessionnelles.vue?vue&type=template&id=5bd8aa77"
import script from "./CoordonneesProfessionnelles.vue?vue&type=script&lang=js"
export * from "./CoordonneesProfessionnelles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports